import { ProductPricingType as ProductPricingTypeApi } from '@vendasta/billing';

export enum ProductPricingType {
  Invalid = 'INVALID',
  Standard = 'STANDARD',
  Stairstep = 'STAIRSTEP',
  Tiered = 'TIERED',
}

export function productPricingTypeFromApi(pptApi: ProductPricingTypeApi | undefined): ProductPricingType {
  switch (pptApi) {
    case ProductPricingTypeApi.PRODUCT_PRICING_TYPE_STANDARD:
      return ProductPricingType.Standard;
    case ProductPricingTypeApi.PRODUCT_PRICING_TYPE_STAIRSTEP:
      return ProductPricingType.Stairstep;
    case ProductPricingTypeApi.PRODUCT_PRICING_TYPE_TIERED:
      return ProductPricingType.Tiered;
  }
  return ProductPricingType.Invalid;
}

export function productPricingTypeToApi(ppt: ProductPricingType): ProductPricingTypeApi {
  switch (ppt) {
    case ProductPricingType.Standard:
      return ProductPricingTypeApi.PRODUCT_PRICING_TYPE_STANDARD;
    case ProductPricingType.Stairstep:
      return ProductPricingTypeApi.PRODUCT_PRICING_TYPE_STAIRSTEP;
    case ProductPricingType.Tiered:
      return ProductPricingTypeApi.PRODUCT_PRICING_TYPE_TIERED;
  }
  return ProductPricingTypeApi.PRODUCT_PRICING_TYPE_INVALID;
}
